import React from 'react';
import moment from 'moment';
import classNames from 'classnames/bind';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/light.css';
import { translate, getLocaldmYDate, getLocaldmYHisDate } from 'utils/common';
import SelectField from '../selectfield';
import { hourBasedStartOptions, hourBasedEndOptions } from './datepickerUtils';


class DatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.flatPickrRef = React.createRef();
        this.dateFormat = props.enableTime ? 'YYYY-MM-DD\THH:mm:ss' : 'YYYY-MM-DD';
        let __this = this;
        this.state = {
            timeRange: null,
            
            selectedDate: null,
            options: {
                //altInput: true,
                // enableTime: true, built in time picker for flatpickr not used
                //altFormat: 'Y-m-d',
                enableTime: props.enableTime,
                enableSeconds: props.enableTime,
                time_24hr:true,
                minDate: props.minDate || 'today',
                maxDate: props.maxDate || '',
                onReady: props.onReady || function () {
                     /* 
                        flatpickr default flow is to empty 
                        preloaded(set) inputs where validation fails
                        but that leads to empty inputs & user gets confused or don't know
                        the already saved date, so the fix below
                     */
                    let that = this;
                    if (!that.input.value) {
                        // direct changing is not working, as its being overwritten by this flatpickr-react plugin
                        setTimeout(() => {
                            const prefillValue = props.value ? getLocaldmYDate(props.value, __this.dateFormat, true).replace("T", " ") : '';
                            that.input.value = prefillValue;
                            // pseudo input element fix for alInput format prefilling validated dates
                            if (that.input.parentElement.children.length > 1) {
                                that.input.parentElement.children[1].value = prefillValue;
                            }
                        }, 15);
                    }
                },
                onClose: props.onClose || function () {

                }
            }
        };
        this.openCalendar = this.openCalendar.bind(this);
        // this.updateTimeRange = this.updateTimeRange.bind(this);
        this.onChange = this.onChange.bind(this);
        // this.onTimeRangeChange = this.onTimeRangeChange.bind(this);
    }

    componentDidMount() {
        // if (this.props.timeRangeEnabled) {
        //     this.updateTimeRange();
        // }
        if (this.props.value) {
            this.setState({ selectedDate: this.props.value });
        }
    }

    componentDidUpdate(prevProps) {
        const { props } = this;
        // if (prevProps.minTime != props.minTime || prevProps.maxTime != prevProps.maxTime) {
        //     this.updateTimeRange();
        // }
        if (prevProps.value != props.value) {
            if (prevProps.fullData && props.fullData && prevProps.fullData.id != props.fullData.id) {
                if (this.flatPickrRef && this.flatPickrRef.current) {
                    this.flatPickrRef.current.node.value = getLocaldmYDate(props.value, this.dateFormat, true).replace("T", " ");
                }
            }
            this.setState({ selectedDate: props.value });
        }
    }
    // updateTimeRange() {
    //     // timeType=start/end
    //     const { timeType, minTime, maxTime } = this.props;
    //     let timeRange = timeType === 'start' ? hourBasedStartOptions : hourBasedEndOptions;
    //     timeRange = timeRange.filter(t => {
    //         const { value } = t;
    //         if (Number.isInteger(minTime)) {
    //             if (value < minTime) {
    //                 return false;
    //             }
    //         }
    //         if (Number.isInteger(maxTime)) {
    //             if (value > maxTime) {
    //                 return false;
    //             }
    //         }

    //         return true;
    //     });
    //     this.setState({ timeRange });
    // }
    openCalendar() {
        this.flatPickrRef.current.flatpickr.open();
    }
    onChange(dateArray, dateString, dateInstance) {
        // var s = moment(String(dateArray)).format('DD-MM-YYYY')
        

        const { timeRangeEnabled, timeType, minTime, maxTime, getDefaultTimeSlotHour } = this.props;
        const { timeRange } = this.state;
        let dateArrayComputed = new Date(dateArray[0])

        if (timeRangeEnabled) {
            // set default time to the lowest available time range
            let defaultHour;
            if (typeof getDefaultTimeSlotHour === 'function') {
                defaultHour = getDefaultTimeSlotHour(dateArrayComputed);
            } else if (timeType === 'start') {
                defaultHour = timeRange[0].value;
            } else {
                defaultHour = timeRange[timeRange.length - 1].value;
            }
            dateArrayComputed.setHours(defaultHour);
            if (timeType === 'end') {
                dateArrayComputed.setMinutes(59);
                dateArrayComputed.setSeconds(59);
            }
        }
        this.setState({ selectedDate: new Date(dateArray[0]) }, () => {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: moment(String(dateArray)).format(this.dateFormat)//dateArrayComputed
                }
            });
        });
    }
    // onTimeRangeChange(e) {
    //     const { selectedDate } = this.state;
    //     const { name, timeType } = this.props;
    //     // checking for NaN
    //     const value = parseInt(e.target.value);
    //     const hoursSelected = value ? value : 0;

    //     let selectedDateTime = new Date(selectedDate)
    //     selectedDateTime.setHours(hoursSelected);
    //     if (timeType === 'end') {
    //         selectedDateTime.setMinutes(59);
    //         selectedDateTime.setSeconds(59);
    //     }
    //     this.props.onChange({
    //         target: {
    //             name: this.props.name,
    //             value: dateArrayComputed
    //         }
    //     }); 
    // }
    render() {
        const { props } = this;
        // time variables
        const { timeRangeEnabled, timeType, minTime, maxTime } = props;
        // flatpickr variables
        const { id, name, value, disabled } = props;

        const { options, timeRange } = this.state;
        if (timeRangeEnabled) {
            var timeRangeValue = value ? value.getHours() : value;
        }
        const readOnlyDate = timeRangeEnabled ? getLocaldmYHisDate(value) : getLocaldmYDate(value, this.dateFormat);
        const showTimeSelector = timeRangeEnabled && timeRange && value;
        const mainClassNames = classNames({
            datepicker: true,
            'd-flex': showTimeSelector,
            'time-enabled': showTimeSelector,
        });
        return (
            <React.Fragment>
                {
                    !props.readOnly &&
                    <React.Fragment>
                        <div className={mainClassNames}>
                            <Flatpickr 
                                ref={this.flatPickrRef}
                                id={id}
                                name={name}
                                value={value}
                                onChange={this.onChange}
                                // dateformat="Y-m-d"
                                // onClose={this.onChange}
                                options={options} 
                                disabled={disabled}
                                //placeholder={this.dateFormat.replace('\T', " ")}
                                dateformat={this.dateFormat}
                            />
                            {/* {
                                showTimeSelector &&
                                <SelectField
                                    name={"datepickertimerange" + name}
                                    selectOptions={timeRange}
                                    onChange={this.onTimeRangeChange}
                                    value={timeRangeValue}
                                />
                            } */}
                            {
                                props.onClear && props.value &&
                                <a className="btn btn-cross" onClick={() => { props.onClear(props.name) }}>&times;</a>
                            }
                        </div>
                        <i onClick={this.openCalendar} className="far fa-calendar-alt"></i>
                    </React.Fragment>

                }
                {
                    props.readOnly &&
                    <div className="form-control ui-disabled">
                        {readOnlyDate ? readOnlyDate.replace('T', " ") : this.dateFormat}
                    </div>
                }
            </React.Fragment>
        )
    }
}

export {
    DatePicker,
};